// import getDisplayDateFromMinutes from './utils/getDisplayDateFromMinutes';
var booleanStatus = function (status) {
    return {
        status: status,
    };
};
var workingHoursStatus = function (workingHours) {
    return {
        status: workingHours,
    };
};
var workDayStatus = function (workDays) {
    return {
        sunday: (workDays & 1) == 1,
        monday: (workDays & 2) == 2,
        tuesday: (workDays & 4) == 4,
        wednesday: (workDays & 8) == 8,
        thursday: (workDays & 16) == 16,
        friday: (workDays & 32) == 32,
        saturday: (workDays & 64) == 64,
    };
};
/**
 * Datapoint configurations.
 */
export default {
    WeekStartDay: {
        datapoint: {
            name: 'WeekStartDay',
            customData: function (weekStartDay) { return [weekStartDay]; },
        },
    },
    WeekStartDayQuick: {
        datapoint: {
            name: 'WeekStartDayQuick',
            customData: function (weekStartDay) { return [weekStartDay]; },
        },
    },
    TimeIncrement: {
        datapoint: {
            name: 'TimeIncrement',
            customData: function (timeIncrement) { return [timeIncrement]; },
        },
    },
    ShowWeekNumbers: {
        datapoint: {
            name: 'ShowWeekNumbers',
            customData: booleanStatus,
        },
    },
    FirstWeekOfYear: {
        datapoint: {
            name: 'FirstWeekOfYear',
            customData: function (firstWeekOfYear) { return [firstWeekOfYear]; },
        },
    },
    WorkingHoursStartTime: {
        datapoint: {
            name: 'WorkingHoursStartTime',
            customData: workingHoursStatus,
        },
    },
    WorkingHoursEndTime: {
        datapoint: {
            name: 'WorkingHoursEndTime',
            customData: workingHoursStatus,
        },
    },
    WorkDays: {
        datapoint: {
            name: 'WorkDays',
            customData: workDayStatus,
        },
    },
};
//# sourceMappingURL=datapoints.js.map